import { Center, Container, Flex, ProgressBar, Text } from "@huub-web/ui";
import type { FC } from "react";
import { mergeClasses } from "@huub-web/utils";
import { useTranslation } from "react-i18next";

import { containerStyle } from "./LoadingScreen.css";

/**
 * LoadingScreen component.
 */
export const LoadingScreen: FC = () => {
  const { t } = useTranslation();

  return (
    <Container className={mergeClasses(containerStyle)}>
      <Center grow>
        <Flex direction="column" gap="l">
          <Text color="currentColor50">{t("vite.loadingScreen")}</Text>
          <ProgressBar variant="infinite" />
        </Flex>
      </Center>
    </Container>
  );
};
